import React, { useCallback } from 'react';
import { useProviderHelpers } from './ProviderHelpers';

const Context = React.createContext();

export const FranchiseProvider = ({ children }) => {
    const { data, execute, clearData } = useProviderHelpers();

    const selectRecord = useCallback(async (props) => {
        await execute({ scope: 'select', url: `Franchise/${props.franchiseId}`, method: 'GET', secure: true });
    }, [execute]);

    const newRecord = useCallback(async (props) => {
        await execute({ scope: 'new', payload: { status: 200, body: props } });
    }, [execute]);

    const createRecord = useCallback(async (props) => {
        await execute({ scope: 'create', url: `Franchise`, method: 'POST', payload: props, secure: true });
    }, [execute]);

    const updateRecord = useCallback(async (props) => {
        await execute({ scope: 'update', url: `Franchise/${props.franchiseId}`, method: 'PUT', payload: props, secure: true });
    }, [execute]);

    const listRecords = useCallback(async () => {
        await execute({ scope: 'list', url: 'Franchise', method: 'GET', secure: true });
    }, [execute]);

    const activeFranchises = useCallback(async () => {
        await execute({ scope: 'activeFranchisesList', url: 'Franchise/GetActiveFranchises', method: 'GET', secure: true });
    }, [execute]);

    const optionRecords = useCallback(async () => {
        await execute({ scope: 'options', url: 'Franchise/Simple', method: 'GET', secure: true });
    }, [execute]);

    const deleteRecord = useCallback(async (props) => {
        await execute({ scope: 'delete', url: `Franchise/${props.franchiseId}`, method: 'DELETE', secure: true });
    }, [execute]);

    const geocodeRecord = useCallback(async (props) => {
        await execute({ scope: 'geocode', url: `Franchise/UpdateGeocode/${props.franchiseId}`, method: 'PUT', secure: true });
    }, [execute]);

    const expiringRecords = useCallback(async (props) => {
        await execute({ scope: 'expiring', url: `Franchise/Expiring/${props.expiresInMonths}`, method: 'GET', secure: true });
    }, [execute]);

    const validateTins = useCallback(async (props) => {
        await execute({ scope: 'validateTins', url: `Franchise/ValidateTins/${props.franchiseId}`, method: 'PUT', secure: true });
    }, [execute]);

    const getIntegrations = useCallback(async (props) => {
        await execute({ scope: 'integrations', url: `Franchise/Integrations/${props.franchiseId}`, method: 'GET', secure: true });
    }, [execute]);

    const updateIntegrations = useCallback(async (props) => {
        await execute({ scope: 'updateintegrations', url: 'Franchise/Integrations', method: 'POST', payload: props, secure: true });
    }, [execute]);

    const value = {
        selectRecord,
        listRecords,
        activeFranchises,
        optionRecords,
        newRecord,
        deleteRecord,
        updateRecord,
        createRecord,
        geocodeRecord,
        expiringRecords,
        validateTins,
        getIntegrations,
        updateIntegrations,
        data,
        clearData
    };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useFranchiseStore = () => React.useContext(Context);
